<template>
  <div class="top-stats-list">
    <div class="iqos top-dishes right-space">
      <h5>{{ $t('stats.top_dishes') }}</h5>
      <ol>
        <li v-for="(item,index) in dishes" :key="index">{{index+1}}. {{ item }}</li>
      </ol>
    </div>

    <div class="iqos top-waiters right-space">
      <h5>{{ $t('stats.top_waiters') }}</h5>
      <ol>
        <li v-for="(item,index) in waiters" :key="index">{{index+1}}. {{ item }}</li>
      </ol>
    </div>

    <div class="iqos top-waiters">
      <h5>{{ $t('stats.top_clients') }}</h5>
      <ol>
        <li v-for="(item,index) in clients" :key="index">{{index+1}}. {{ item }}</li>
      </ol>
    </div>
  </div>
</template>

<style scoped>
h5 {
  font-size: 2.2vh;
  margin-bottom: 0;
  color: #ededed;
}

.top-stats-list {
  display: flex;
}

.top-dishes {
  width: 30vh !important;
}

.top-stats-list .iqos {
  width: 22.1vh;
  margin: 0;
  max-height: 37.5vh;
  color: #ededed;
  min-height: 37.5vh;
  overflow-y: auto;
  padding: 2vh;

}

.top-stats-list ol {
  margin: 1.1vh 0 0 0;
  white-space: pre-wrap;
  overflow-x: hidden;
  min-height: 25vh;
  width: 100%;
  font-size: 2vh;
}

ol li {
  line-height: 1.2;
  font-size: 1.8vh;
  padding-top: 1.1vh;
}

li:last-child {
  padding-bottom: 3.3vh;
}

.top-clients ol {
  max-width: 100%;
}
</style>

<script>
export default {
  props: {
    waiters: Array,
    dishes: Array,
    clients: Array,
  },
};
</script>